const t = {
  name: "ArrowRightSmall",
  dimensions: { width: 24, height: 24 },
  content: `
    <svg>
        <path d="M16.1717 11.5859L3.58576 11.5859L3.58576 13.5859L16.1714 13.5859L12.1716 17.5858L13.5858 19L20 12.5858L13.5858 6.17157L12.1716 7.58579L16.1717 11.5859Z" fill="currentColor"/>
    </svg>

    `
};
export {
  t as ArrowRightSmall
};
